import Banner from "./Banner";
import { useEffect } from "react";
import FounderMsg from "./FounderMsg";
import SectionOne from "./SectionOne";
import FoundersMeet from "./FoundersMeet";
import ImageGallery from "./ImageGallery";
import VisionMission from "./VisionMission";
import WebLayout from "layout/webLayout.js";
import { founderMsgArr, vetProjectsMsg } from "utilities/data";

const AboutPageSections = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <WebLayout>
      <Banner />
      <SectionOne />
      <VisionMission />
      <FounderMsg
        messageHeader="A message from our founders"
        paragraphs={founderMsgArr}
      />
      <FoundersMeet />
      <FounderMsg
        messageHeader="How we vet projects"
        paragraphs={vetProjectsMsg}
      />
      <ImageGallery />
    </WebLayout>
  );
};

export default AboutPageSections;
